module.exports = "/images/gg.svg?9f33cbf42b67b78aee6eaec973e3d98b";